<template>
  <div class="goodList flex justify-between">
    <div class="good-item">
      <div class="item relative" v-for="(good, index) in goodList" :key="index">
        <div class="bg-white mar10-b radius10 overflow" v-if="index % 2 == 0">
          <div
            class="good-img flex justify-center item-center"
            @click="routerClick(`/goodDetails/${good.goodsId}`)"
          >
            <van-image v-if="good.picUrl" lazy-load :src="`${good.picUrl}?imageView2/1/w/345/h/310`" />
            <img v-else src="@/assets/images/good/good-none.png" class="radius10" />
          </div>
          <div class="w100m pad10">
            <div class="ellipsis_two fb f14">
              {{ good.name }}
            </div>
            <div class="flex items-center justify-between">
              <div class="c-price fb">
                <template v-if="good.marketPrice">
                  <span class="f10">￥</span>
                  <span class="f16">{{ good.price[0] }}</span>
                  <span class="f10">.{{ good.price[1] }}</span>
                </template>
                <span v-else>点击询价</span>
              </div>
              <img v-if="good.marketPrice" @click.stop="addCart(good)" class="w20" src="@/assets/images/index/cart-add.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="good-item">
      <div class="item relative" v-for="(good, index) in goodList" :key="index">
        <div class="bg-white mar10-b radius10 overflow" v-if="index % 2 == 1">
          <div
            class="good-img flex justify-center item-center"
            @click="routerClick(`/goodDetails/${good.goodsId}`)"
          >
            <van-image v-if="good.picUrl" lazy-load :src="`${good.picUrl}?imageView2/1/w/345/h/310`" />
            <img v-else src="@/assets/images/good/good-none.png" class="radius10" />
          </div>
          <div class="w100m pad10">
            <div class="ellipsis_two fb f14">
              {{ good.name }}
            </div>
            <div class="flex items-center justify-between">
              <div class="c-price fb">
                <template v-if="good.marketPrice">
                  <span class="f10">￥</span>
                  <span class="f16">{{ good.price[0] }}</span>
                  <span class="f10">.{{ good.price[1] }}</span>
                </template>
                <span v-else>点击询价</span>
              </div>
              <img v-if="good.marketPrice" @click.stop="addCart(good)" class="w20" src="@/assets/images/index/cart-add.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import { mapState } from "vuex";
import common from "@/assets/js/common";

export default {
  props: {
    goodList: Array
  },
  data() {
    return {
      isShow: false
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
  },
  methods: {
    // 加入购物车
    addCart(goods) {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      const params = {
        goodsId: goods.goodsId,
        goodsQuantity: 1,
        fromShopId: goods.shopIds
      };
      this.$store.dispatch("goodDetails/goodDetails/addCart", { params }).then((data) => {
        if (data.success === true) {
          Toast.success("添加成功");
          this.$emit("getCountCart");
        } else if (data.errorcode === -2) {
          window.location.href = `${process.env.VUE_APP_APP}mob/goods/isShowDisplayPrice.do?goodsId=${goods.goodsId}&url=/mob/shop/shopDetail/${goods.shopIds}`;
        } else {
          Toast.fail(data.errormsg);
        }
      });
    },

    // 点击跳转
    routerClick(url) {
      if (!url) {
        return;
      }
      this.$router.push(url);
    }
  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
